export default "__VITE_ASSET__3f3e3910__"